import { useState } from 'react';
import cls from 'classnames';
import Icon from '@/components/common/icons';
import Form from './Form';
import Success from './Success';
import styles from './index.module.scss';

const ContactComp: React.FC = () => {
  const [success, setSuccess] = useState<boolean>(false);

  const handleSuccess = (value: boolean) => {
    setSuccess(value);
  };

  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <Icon className={cls(styles.bg, styles.bg__left)} type="contactUsBg1" />
        <Icon
          className={cls(styles.bg, styles.bg__right)}
          type="contactUsBg2"
        />
        {success ? <Success /> : <Form handleSuccess={handleSuccess} />}
      </div>
    </div>
  );
};

export default ContactComp;
